import { render, staticRenderFns } from "./IncDeliveryAddresses.vue?vue&type=template&id=0c7918f8"
import script from "./IncDeliveryAddresses.vue?vue&type=script&lang=js"
export * from "./IncDeliveryAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports